import { CarouselSchema, MessageStepSchema } from '@feedyou/schema'

import { Search } from '../../../types'
import {
  createConfigs,
  FoundOccurrence,
  searchMutableObject
} from '../../../../../features/flowSearch'

export const search: Search<MessageStepSchema> = (step, query) => {
  const directResults = searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      storage: ['storageSummary.rows.%key%.storage'],
      text: [
        'condition',
        'message',
        'messageMale',
        'messageFemale',
        'storageSummary.rows.%key%.title',
        'storageSummary.rows.%key%.storage'
      ]
    })
  )

  const carouselResults = step.carousel?.flatMap(item => searchInCarouselItem(item, query)) ?? []

  return [...directResults, ...carouselResults]
}

function searchInCarouselItem(
  carouselItem: CarouselSchema,
  query: string
): FoundOccurrence<'partial'>[] {
  return searchMutableObject(
    carouselItem,
    query,
    { type: 'carousel', id: carouselItem.id! },
    createConfigs({
      id: ['id'],
      text: [
        'condition',
        'title',
        'subtitle',
        'text',
        'buttons.%key%.url',
        'buttons.%key%.title',
        'buttons.%key%.msg'
      ]
    })
  )
}
